import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const BorderRadiusIcon = (props?: SvgProps) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M3.332 16.25V13C3.332 10.1997 3.332 8.79961 3.877 7.73005C4.356 6.78924 5.121 6.02433 6.062 5.54497C7.132 5 8.532 5 11.332 5H16.665"
      className="stroke-current"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
